import { useContext } from 'react';
import { BrandingUiContext, type PlatformBrandingContextValue } from './branding-ui-context';

export function usePlatformBranding(): PlatformBrandingContextValue {
  const ctx = useContext(BrandingUiContext);
  if (!ctx) {
    throw new Error('usePlatformBranding must be used within PlatformBrandingProvider');
  }
  return ctx;
}
